import { atom } from 'recoil';
import { GlobalStyle } from '../../types/Config';
import { DEFAULT_VALUES } from '../../../config/defaultValues/defaultValues';

export const sidebarExtendedState = atom<boolean>({
  key: 'sidebarExtendedState',
  default: true,
});

export const layoutExtendedState = atom<boolean>({
  key: 'layoutExtendedState',
  default: false,
});

export const themeState = atom<GlobalStyle | null>({
  key: 'themeState',
  default: null,
});

export const highlightedRowState = atom<string | null>({
  key: 'highlightedRowState',
  default: null,
});

export const currencyState = atom<string>({
  key: 'currencyState',
  default: DEFAULT_VALUES.currencyState,
});

export const modalOpenState = atom<boolean>({
  key: 'modalState',
  default: false,
});

export const defaultCountryState = atom<string | null>({
  key: 'defaultCountryState',
  default: DEFAULT_VALUES.defaultCountryState,
});

export const isInternationalCountryNameState = atom<boolean>({
  key: 'isInternationalCountryNameState',
  default: DEFAULT_VALUES.isInternationalCountryName,
});

export const cardStyleState = atom<any>({
  key: 'cardStyle',
  default: DEFAULT_VALUES.defaultCardStyle,
});
